import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { SiteDownComponent } from './core/components/site-down/site-down.component';
import { siteUpGuard } from './core/guards/server-connection.guard';
import { LoginSsoComponent } from './public/login/login-sso/login-sso.component';
import { LogoutComponent } from './public/logout/logout.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    // Intentionally not lazy-loading
    path: 'site-down',
    component: SiteDownComponent,
    canDeactivate: [siteUpGuard]
  },
  {
    // Intentionally not lazy-loading
    path: 'login',
    component: LoginSsoComponent
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'login-legacy',
    loadComponent: () => import('./public/login/login.component').then((m) => m.LoginComponent)
  },
  {
    // Intentionally not lazy-loading
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./public/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'update-password',
    loadComponent: () =>
      import('./public/update-password/update-password.component').then((m) => m.UpdatePasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./public/update-password/update-password.component').then((m) => m.UpdatePasswordComponent)
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./public/terms-of-use/terms-of-use.component').then((m) => m.TermsOfUseComponent)
  },
  {
    path: 'private',
    loadChildren: () => import('./private/private.routes').then((m) => m.privateRoutes)
  },
  {
    path: '**',
    loadComponent: () => import('./core/components/no-content/no-content.component').then((m) => m.NoContentComponent)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: NoPreloading,
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
